import type { TOC } from '@ember/component/template-only';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import ManagePage from 'tio-employee/components/tas/applications/manage/manage-page';
import type { ManageFixture } from 'tio-employee/utils/tas/manage-fixtures';

interface GallerySignature {
  Args: { model: ManageFixture[] };
}

// Dev-only showcase route — labels are intentionally bare (not localized).
const ManageGallery: TOC<GallerySignature> = <template>
  {{! template-lint-disable no-bare-strings }}
  <VStack>
    <PageHeader
      @title="Manage screen — state gallery"
      @subtitle="Dev-only preview of every manage / Needs Your Attention state from fixtures (flag + non-prod gated)."
    />

    {{#each @model as |fixture|}}
      <div class="tio-col gap-3">
        <div class="tio-row flex-wrap gap-2 border-b tio-border-default pb-1">
          <span class="tio-text-xs-semibold tio-fg-info uppercase">{{fixture.key}}</span>
          <span class="tio-text-sm-medium tio-fg-secondary">{{fixture.label}}</span>
        </div>
        <div class="tio-bg-sunken rounded-2xl border tio-border-default p-4">
          <ManagePage @application={{fixture.application}} />
        </div>
      </div>
    {{/each}}
  </VStack>
</template>;

export default ManageGallery;
